import { WbsLabelValueSearchResult } from 'graphql/types';
import { FacetOption } from '../type';

export const options: WbsLabelValueSearchResult[] = [
  {
    id: 'non-billable',
    displayText: 'Non Billable'
  },
  {
    id: 'urn:replicon:project-specific-billing-rate',
    displayText: 'Project Rate'
  },
  {
    id: 'urn:replicon:user-specific-billing-rate',
    displayText: 'User Rate'
  }
];

export const transformBilling = (
  data: WbsLabelValueSearchResult[] | undefined
): FacetOption[] =>
  (data || []).map((billing) => ({
    label: billing.displayText!,
    key: billing.displayText!,
    id: billing.id || undefined
  }));

const cleanSearchTerm = (value: string): string =>
  value.replace(/['",]+/g, '').toLowerCase();

export const searchBilling = (
  searchTerm: string
): WbsLabelValueSearchResult[] => {
  const $term = cleanSearchTerm(searchTerm);
  const billingRates = options.filter((i: WbsLabelValueSearchResult) =>
    i.displayText.toLowerCase().includes($term)
  );
  return billingRates;
};
